import styled, { css, keyframes } from 'styled-components';

import { device } from 'components/styles/MediaQuery';

const glow = keyframes`
  0% {
    filter: drop-shadow(0 0 2px orange);
  }
  100% {
    filter: drop-shadow(0 0 2px transparent);
  }
`;

interface ScBonanzaPromoSectionProps {
  isMobile: boolean;
  bgMenu: string;
  isHighlighted: boolean;
}

export const ScBonanzaPromoSection = styled.div<ScBonanzaPromoSectionProps>`
  display: grid;
  place-items: center;
  padding: ${({ isMobile }) => (isMobile ? '12px' : '7px 12px')};
  min-height: 80px;
  background: url(${({ bgMenu }) => bgMenu}) left top / 1000px 100% no-repeat;
  border-radius: ${({ isMobile }) => (isMobile ? '16px' : '8px')};
  gap: ${({ isMobile }) => (isMobile ? '0' : '4px')};
  cursor: pointer;
  color: ${({ theme }) => theme.whiteColor};

  .under-progress-text {
    width: 100%;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px;
    margin-top: 4px;
  }

  .info {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.16px;
    width: 100%;

    span b {
      margin-right: 8px;
    }

    .text {
      width: 100%;
      display: flex;
      flex-direction: column;
      @media (${device.mobile}) {
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;

        & > span:last-of-type {
          display: block;
          margin-bottom: 4px;
        }
      }
    }

    & > .addons {
      display: flex;
      align-items: center;
      flex-direction: ${({ isMobile }) => (isMobile ? 'row' : 'column')};
      row-gap: 8px;

      ${({ isMobile }) =>
        !isMobile &&
        css`
          justify-content: center;
        `};

      @media (${device.mobile}) {
        gap: 8px;
      }

      .title {
        font-size: 10px;
        font-weight: 700;
        line-height: 14px;
        width: 100%;
        text-align: ${({ isMobile }) => (isMobile ? 'left' : 'center')};

        @media (${device.mobile}) {
          font-size: 14px;
          line-height: 20px;
        }
      }

      & > img {
        flex-shrink: 0;
        object-fit: contain;
        object-position: center;

        ${({ isHighlighted }) =>
          isHighlighted &&
          css`
            filter: drop-shadow(0 0 2px orange);
            animation: ${glow} 1s infinite alternate;
          `}
      }

      & > svg {
        flex-shrink: 0;
        margin-left: auto;

        path {
          fill: ${({ theme }) => theme.grayColor1};
        }
      }
    }
  }
`;
